import { type NextPageWithLayout } from 'next';
import { withPageAuth } from '@/lib/auth/HOC/withPageAuth';
import { ProfileEditPage } from '@/module/profile/edit';
import { getProfileSidebarLayout } from '@/module/profile/layout/ProfileSidebarLayout';
import { getDefaultStaticProps } from '@/utils';
const ProfileEdit: NextPageWithLayout = () => {
  return <ProfileEditPage data-sentry-element="ProfileEditPage" data-sentry-component="ProfileEdit" data-sentry-source-file="index.page.tsx" />;
};
ProfileEdit.getLayout = function (page) {
  return getProfileSidebarLayout(page);
};
export default withPageAuth(ProfileEdit, {
  callbackUrl: '/profile/edit'
});
export const getStaticProps = getDefaultStaticProps;